<template>
    <div class="signin">
        <img class="close" src="../../assets/img/cross.svg" alt="X" @click="onClose"/>
        <SectionTitle withDivider :title="config.HOME_STEPS_TITLE"/>
        <section class="steps">
            <div v-for="(step, index) in homeSteps" :key="index" class="step">
                <h3 class="number" :style="numberStyles">
                    {{ index + 1 }}
                </h3>
                <div class="text">
                    <h4 :style="configStyles.primary.text">
                        {{ step.title }}
                    </h4>
                    <p>{{ step.description }}</p>
                </div>
            </div>
        </section>
        <section class="actions">
            <div class="overlay"/>
            <Button :color="config.COLOR_PRIMARY" @click="onLogin">
                {{ config.HOME_CTA }}
            </Button>
        </section>
    </div>
</template>
<script>
import contrast from 'contrast';

import { SolutionConsumer } from '../../mixins';
import { SectionTitle } from '../../components/shared';

export default {
    name: 'SignIn',
    components: { SectionTitle },
    mixins: [SolutionConsumer],
    computed: {
        numberStyles () {
            return {
                background: this.config.COLOR_SECONDARY,
                color: contrast(this.config.COLOR_SECONDARY) === 'light' ? '#000' : '#fff',
            };
        },
    },
    methods: {
        onLogin () {
            this.$emit('login');
        },
        onClose () {
            this.$emit('close');
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.signin {
    @include container(20px);
    gap: 0;
    align-content: center;
    justify-items: center;
    position: relative;
    border-radius: 10px 10px 0 0;
    background-color: $white;
    box-shadow: 8px 8px 24px 0 rgba($black, .1);
    backdrop-filter: blur(4px);

    > .close {
        @include square(32px);
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
    }

    > .steps {
        max-height: 100%;
        overflow-y: auto;
        padding-bottom: 20px;

        > .step {
            display: flex;
            align-items: center;

            &:not(:last-of-type):not(:only-of-type) {
                margin-bottom: 10px;
            }

            > .number {
                @include square(32px);
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 20px 0 0;
                border-radius: 50%;
                line-height: 1em;
            }

            > .text {
                flex: 1;

                > h4 {
                    margin: 6px 0;
                    font-weight: 700;
                }

                > p {
                    font-weight: 400;
                    line-height: 1.4;
                }
            }
        }
    }

    > .actions {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;

        > .overlay {
            position: absolute;
            bottom: 100%;
            width: 100%;
            height: 20px;
            background: linear-gradient(transparent, $white);
        }
    }
}
</style>
